import request from "@/utils/request";
import config from "@/config";
let serveUrl = config.baseUrl;
// let serveUrl = 'http://192.168.2.71:20001/';
let personalCenterBaseUrl = config.personalCenterBaseUrl;

let adminCenterUrl = config.adminCenterUrl;
// //获取登录者信息
// export function getPersonalCenter() {
//   return request({
//     url: `${personalCenterBaseUrl}api/v1/personal/user/info`,
//     method: "get",
//     headerType: "portal"
//   });
// }
// 获取栏目列表
export function getColumnList(data) {
  return request({
    url: `${serveUrl}portalCenter/api/rest/center/cms/getColunmList?columnName=${data.columnName}`,
    method: "get",
		headerType: "portal"
  });
}

// 删除栏目
export function deleteColumnList(data) {
  return request({
    url: `${serveUrl}portalCenter/api/rest/center/cms/deleteCmsInfo`,
    method: "get",
    params: data,
  });
}


// 查询栏目
export function getOneColumn(data) {
  return request({
    url: `${serveUrl}portalCenter/api/rest/center/cms/getAllInfo`,
    method: "get",
    params: data,
  });
}


// 提交表单
export function submitForm(data) {
	return request({
		url: `${serveUrl}portalCenter/api/rest/center/cms/saveCmsInfo`,
		method: "post",
		data: data
	})
}
// 获取栏目模版列表
export function getColumnTemplateList(data) {
  return request({
    url: `${serveUrl}v1/cms/template/findListTemplate?templateType=${data.templateType}`,
    method: "get",
    headerType: "portal"
  });
}

// 获取所有部门
export function getOrganizationTree() {
  return request({
    url: `${adminCenterUrl}api/v1/base/organization/organizationTree`,
    method: "get",
    headerType: "portal"
  });
}

// 获取所有用户组
export function getGroupTree() {
  return request({
    url: `${adminCenterUrl}api/v1/base/group`,
    method: "get",
    headerType: "portal"
  });
}

// 获取所有角色
export function getRoleTree() {
  return request({
    url: `${serveUrl}v1/role/findAll`,
    method: "get",
    headerType: "portal"
  });
}